import { ROUTES_WITH_MOBILE_APP_BANNER } from "../../../../constants/env";

export function isAllowedRoute(route: string) {
  const isMatching = ROUTES_WITH_MOBILE_APP_BANNER.some((allowedRoute) =>
    typeof allowedRoute === "string" ? allowedRoute === route : allowedRoute.test(route)
  );

  return isMatching;
}
